import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import cartConfig from "emun.cart/cart.config";
import orderConfig from "emun.order/order.config";
import labels from "emun.order/_labels";
import required from "emun.order/_required";
import ServiceBus from "servicestack/service-bus";
import resolve from "ioc/resolve";
import modals from "webmodals/modals";

const statuses = ["Open", "Cart", "Completed", "On Hold", "Cancelled", "Review", "Quote"];
const DELIVERY_TYPE_DELIMTER = "Delivery Type: ";
//const transactionTypes = ["Order", "Quote"];
const $localStorage = resolve("$localStorage");

const parseEmails = (list) =>
  `${list || ""}`.split(",").filter((email) => email && email.indexOf("@") > 1);
export default class OrderHeaderFeildsetController {
  constructor($scope, $session) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.config = cartConfig;
    $ctrl.orderConfig = orderConfig;
    $ctrl.config = Object.assign({}, cartConfig, orderConfig);
    if ($ctrl.$session.isCorpOrAbove()) $ctrl.orderConfig.virtualSources = null;
    $ctrl.statuses = statuses;
    $ctrl.$session = $session;
    //$ctrl.transactionTypes = transactionTypes;
      $ctrl.today = moment.utc().startOf('day');
    $ctrl.labels = labels;
    $ctrl.required = required;
    $ctrl.bus = new ServiceBus();
    $ctrl.retailerVendors = [];
    $scope.$watch(
      () => $ctrl.order.purchaseOrder,
      () => {
        const po = $ctrl.order.purchaseOrder;
        if (po && po.trim() !== "") {
          $ctrl.duplicatePurchaseOrders.criteria.IdNotEqualTo = $ctrl.order.id;
          $ctrl.duplicatePurchaseOrders.criteria.retailerId = $ctrl.order.retailerId;
          $ctrl.duplicatePurchaseOrders.criteria.purchaseOrder = po;
          $ctrl.duplicatePurchaseOrders.load();
        }
      }
    );
    
    if ($ctrl.config.maxCancelDaysAfterShip) {
      $ctrl.maxCancelDate = moment
      .utc($ctrl.order.shipOn)
      .add($ctrl.config.maxCancelDaysAfterShip, "days");
    }
    //if ($ctrl.labels.sourceId && $ctrl.orderConfig.virtualSources && !$ctrl.$session.hasEnvTag('Showroom')) {
    //	$ctrl.order.sourceId = null;
    //}
  }

  deliveryTypes(val, checked) {
    const $ctrl = this;
    let list = orderConfig.availableDeliveryTypes.filter(
      (dt) => ($ctrl.order.note || "").indexOf(dt) >= 0
    );
    if (val) {
      //console.info("deliveryTypes", { val, checked, note: $ctrl.order, list });
      $ctrl.order.note = ($ctrl.order.note || "").split(
        DELIVERY_TYPE_DELIMTER
      )[0];
      if (checked) {
        list.push(val);
      } else {
        list = list.filter((dt) => dt !== val);
      }
      if (list.length) {
        $ctrl.order.note += DELIVERY_TYPE_DELIMTER + list.join(" ");
      }
    }
    return list;
  }

  $onInit() {
    const $ctrl = this;
    $ctrl.loadQueries();
    if ($ctrl.order.vendorId) {
      $ctrl.findVendor($ctrl.order.vendorId).then((results) => {
        const vendor = results.filter((v) => v.id === $ctrl.order.vendorId)[0];
        $ctrl.setVendor(vendor);
      });
    }
    //console.debug("order", $ctrl.order.salesRepId, $ctrl.order);
    if ($ctrl.order.salesRepId) {
      $ctrl.findReps($ctrl.order.salesRepId).then((results) => {
        const rep = results.filter((r) => r.id === $ctrl.order.salesRepId)[0];
        $ctrl.setRep(rep);
      });
    }
    //if ($ctrl.order.writingRepId) {
    //	$ctrl.findReps($ctrl.order.writingRepId).then(results => {
    //		const rep = results.filter(
    //			r => r.id === $ctrl.order.writingRepId
    //		)[0];
    //		$ctrl.setWritingRep(rep);
    //	});
    //}

    if (
      ($ctrl.order.exported ||
        $ctrl.order.status == "Open" ||
        $ctrl.order.status == "Completed") &&
      !$ctrl.$session.isAgency()
    ) {
      const minDate = moment.utc($ctrl.order.shipOn); //.startOf("day");
      $ctrl.minDate = minDate;
    } else if (cartConfig.shipDateDays) {
      $ctrl.minDate = moment
        .utc()
        .add(cartConfig.shipDateDays, "day")
        .startOf("day");
    } else {
      $ctrl.minDate = moment.utc().startOf("day");
    }
    const { minShipDatesPerOrder = 0 } = $ctrl.$session;
    if (!Array.isArray($ctrl.order.shipOns)) {
      $ctrl.order.shipOns = _.range(minShipDatesPerOrder).map((i) =>
        moment.utc($ctrl.minDate).add(i, "M").startOf("day")
      );
    } else {
      $ctrl.order.shipOns = $ctrl.order.shipOns.map(
        (d) => moment.utc(d) //.startOf("day")
      );
    }
    if ($ctrl.order.shipOns.length > 1) {
      delete $ctrl.order.shipOn;
    } else {
      delete $ctrl.order.shipOns;
    }

    if ($ctrl.order && $ctrl.order.email) {
      $ctrl.emails = parseEmails($ctrl.order.email);
    }
    if ($ctrl.order && $ctrl.order.purchaser && $ctrl.order.purchaser.email) {
      $ctrl.emails = parseEmails($ctrl.order.purchaser.email);
    }
    if ($ctrl.order && $ctrl.order.reviewedBy)
      $ctrl.shareWith = $ctrl.order.reviewedBy.split(",");
    if ($ctrl.order.retailerId) {
      return $ctrl.bus
        .send(`QueryRetailers.json?Id=${$ctrl.order.retailerId}&fields=${orderConfig.retailerSearchFields}`, {
          op: "OrderHeaderFieldset",
        })
        .then(
          ({
            data: {
              results: [retailer],
            },
          }) => {
            if (retailer) {
              $ctrl.selectRetailer(retailer, true);
              if ($ctrl.order.vendorId) {
                $ctrl.vendorSelected();
              }
            } else {
              console.warn("retailer not found", $ctrl.order.retailerId);
            }
          }
        );
    }
  }

  loadQueries() {
    const $ctrl = this;
    $ctrl.shippingMethods = new AutoQuery({
      url: "QueryShippingMethods.json",
      orderBy: "Name",
      criteria: {
        op: "OrderHeaderFieldset",
      },
      autoLoad: true,
      pageSize: 1000,
    });
    $ctrl.sources = new AutoQuery({
      url: "QueryOrderSources.json",
      autoLoad: true,
      criteria: {
        op: "OrderHeaderFieldset",
      },
      onLoaded: (args) => $ctrl.sourcesLoaded(args),
      take: 1000,
    });
    $ctrl.showcodes = new AutoQuery({
      url: "QueryShowCodes.json",
      autoLoad: true,
      criteria: {
        op: "OrderHeaderFieldset",
      },
      take: 1000,
      onLoaded: (args) => $ctrl.showcodesLoaded(args),
    });
    $ctrl.showVendorLocations = new AutoQuery({
      url: "QueryShowVendorLocations.json",
      autoLoad: true,
      criteria: {
        op: "OrderHeaderFieldset",
        showCodeId: $ctrl.order.showCodeId,
        vendorId: $ctrl.order.vendorId,
      },
      take: 1000,
      onLoaded: (args) => $ctrl.showVendorLocationsLoaded(args),
    });
    $ctrl.transactionTypes = new AutoQuery({
      url: "QueryTransactionTypes.json",
      orderBy: "Description",
      criteria: {
        op: "OrderHeaderFieldset",
      },
      autoLoad: true,
      pageSize: 1000,
      onLoaded: (args) => $ctrl.transactionTypesLoaded(args),
    });
    $ctrl.warehouses = new AutoQuery({
      url: "QueryWarehouses.json",
      orderBy: "Name",
      autoLoad: false,
      criteria: {
        op: "OrderHeaderFieldset",
        TransactionTypeId: null,
      },
      pageSize: 1000,
      onLoaded: (args) => $ctrl.warehousesLoaded(args),
    });
    $ctrl.containers = new AutoQuery({
      url: "QueryContainers.json",
      orderBy: "Name",
      autoLoad: false,
      criteria: {
        op: "OrderHeaderFieldset",
        WarehouseId: null,
      },
      pageSize: 1000,
      onLoaded(args) { },
    });
    $ctrl.terms = new AutoQuery({
      url: `QueryPaymentTerms.json`,
      criteria: {
        retailerId: $ctrl.order.retailerId,
        cartId: $ctrl.order.id,
        vendorId:
          $ctrl.order.vendorId != null && $ctrl.order.vendorId != 0
            ? $ctrl.order.vendorId
            : undefined,
      },
      take: 1000,
      autoLoad: false,
      orderBy: "Name",
      onLoaded: (args) => $ctrl.termsLoaded(args),
    });
    $ctrl.shippingMethods = new AutoQuery({
      url: "QueryShippingMethods.json",
      criteria: {
        op: "OrderHeaderFieldset",
        shipViaId: $ctrl.order.retailer.shipMethodId,
      },
      orderBy: "Name",
      autoLoad: false,
      pageSize: 1000,
      onLoaded: (args) => $ctrl.shippingMethodsLoaded(args),
    });
    var locationsUrl = "QueryRetailerShippingLocations.json?Status=Active";
    if ($ctrl.config.allowInactiveCustomerOrder)
      locationsUrl = locationsUrl.replace("Status=Active", "");
    $ctrl.locations = new AutoQuery({
      url: locationsUrl,
      orderBy: "City,Name",
      critiera: {
        op: "OrderHeaderFieldset",
        Status: "Active",
      },
      autoLoad: false,
      pageSize: 5000,
      onLoaded: (args) => $ctrl.locationsLoaded(args),
    });

    $ctrl.users = new AutoQuery({
      url: "QueryUsers.json?active=true",
      orderBy: "FullName",
      autoLoad: false,
      pageSize: 500,
      onLoaded: function(args) {
        $ctrl.users = args.results;
      }
    });

    $ctrl.contacts = new AutoQuery({
      url: "QueryRetailerContacts.json?Active=true",
      orderBy: "Name",
      take: 500,
      critiera: {
        op: "OrderHeaderFieldset",
        Active: true,
      },
      autoLoad: false,
      onLoaded: function (args) {
        $ctrl.contactsLoaded(args);
        $ctrl.contactsWithEmail = args.results.filter(function (obj) {
          return obj.email !== "" && obj.email !== null;
        });
        //add the email from order if it isn't a contact
        $ctrl.emails.forEach(function (email) {
          var orderEmail = $ctrl.contactsWithEmail.filter(function (obj) {
            return obj.email === email;
          });

          if (
            orderEmail === null ||
            (orderEmail.length === 0 && email && email !== "")
          ) {
            var contact = {
              name: "no name",
              email: email,
            };
            $ctrl.contactsWithEmail.push(contact);
          }
        });
      },
    });
    $ctrl.duplicatePurchaseOrders = new AutoQuery({
      url: "QueryCarts.json?duplicatePurchaseOrders=1",
      orderBy: "Id",
      critiera: {
        op: "OrderHeaderFieldset",
        IdNotEqualTo: $ctrl.order.id,
        retailerId: $ctrl.order.retailerId,
      },
      autoLoad: false,
      onLoaded: (args) =>
        ($ctrl.poIds = args.results.map((m) => m.id).join(", ")),
    });
    $ctrl.bus
      .send("QueryPriceLists.json?GroupBy=PriceListId,Position&OrderBy=Position,PriceListId", {
        op: "OrderHeaderFieldset",
      })
      .then((res) => $ctrl.priceListsLoaded(res));
  }

  findReps(val) {
    let $ctrl = this;
    let url = `QuerySalesReps.json?Take=15&JsConfig=ExcludeDefaultValues&Search=${val}&OrderBy=Id`; //
    return $ctrl.bus
      .send(url, {
        op: "OrderHeaderFieldset",
      })
      .then((res) => res.data.results);
  }

  setRep(rep) {
    const $ctrl = this;
    if (!rep) rep = {};
    $ctrl.order.salesRep = rep;
    $ctrl.order.salesRepId = rep.id;
  }

  sourceSelected() {
    const $ctrl = this;
  }

  showcodeSelected() {
    const $ctrl = this;
    $ctrl.showVendorLocations.filter("showCodeId", $ctrl.order.showCodeId);
  }

  showVendorLocationSelected() {
    const $ctrl = this;
  }

  parseShareWith(item, model) {
    let $ctrl = this;
    if ($ctrl.shareWith.length) $ctrl.order.reviewedBy = $ctrl.shareWith.join(",");
  }

  parseEmail(item, model) {
    let $ctrl = this;
    $ctrl.order.email = $ctrl.emails.join(",");
  }

  addEmail(search) {
    let $ctrl = this;
    var contact = {
      name: "no name",
      email: search,
    };
    return contact;
  }

  updateVendorCustId() {
    const $ctrl = this;
    if ($ctrl.retailerVendors.length) {
      $ctrl.retailerVendors[0].vendorCustId = $ctrl.vendorCustId;
      $ctrl.bus.send("UpdateRetailerVendor.json", $ctrl.retailerVendors[0]);
    } else {
      var request = {
        RetailerId: $ctrl.order.retailerId,
        VendorId: $ctrl.order.vendorId,
        VendorCustId: $ctrl.vendorCustId,
      };
      $ctrl.bus.send("CreateRetailerVendor.json", request);
    }
  }
  selectTerm() {
    const $ctrl = this;
    $ctrl.selectedTerm = $ctrl.terms.results.filter(r => r.id == $ctrl.order.paymentTermsId)[0];
  }

  vendorSelected() {
    const $ctrl = this;
    $ctrl.showVendorLocations.filter("vendorId", $ctrl.order.vendorId);

    if ($ctrl.order.retailer) {
      $ctrl.bus
        .send(
          `QueryRetailerVendors.json?fields=vendorId,vendorCustId&RetailerId=${$ctrl.order.retailerId}&VendorId=${$ctrl.order.vendorId}`,
          {
            op: "OrderHeaderFieldset",
          }
        )
        .then(function (response) {
          $ctrl.retailerVendors = response.data.results;
          if (response.data.results.length > 0) {
            $ctrl.vendorCustId = response.data.results[0].vendorCustId;
          }
        });
    }
    if ($ctrl.$session.isAgency() && $ctrl.order.vendorId) {
      $ctrl.bus
        .send(
          `QueryPriceLists.json?GroupBy=PriceListId&VendorId=${$ctrl.order.vendorId}`,
          {
            op: "OrderHeaderFieldset",
          }
        )
        .then((res) => $ctrl.priceListsLoaded(res));
      $ctrl.terms.criteria.vendorId = $ctrl.order.vendorId;
      $ctrl.terms.load();
    }
  }

  findRetailers(val) {
    const $ctrl = this;
    var search = encodeURIComponent(val);
    //console.info("decode", search);
    //console.info("encode", encodeURIComponent(val))
    let url = `QueryRetailers.json?Take=25&fields=${orderConfig.retailerSearchFields}&Status=Active&Search=${search}&OrderBy=CompanyName`; //
    if ($ctrl.config.allowInactiveCustomerOrder)
      url = url.replace("&Status=Active", "");
    return $ctrl.bus
      .send(url, {
        op: "OrderHeaderFieldset",
      })
      .then((res) =>
        res.data.results.map((retailer) =>
          Object.assign(retailer, { config: cartConfig })
        )
      );
  }

  selectRetailer(val, force) {
    const $ctrl = this;
    var retailerChanged = false;
    if ($ctrl.order.retailerId !== val.id) retailerChanged = true;
    if (retailerChanged) {
      $ctrl.order.shippingLocationId = "";
      $ctrl.order.discountPercentage = 0;
    }

    $ctrl.order.retailer = val;
    $ctrl.order.billingLocation = val;
    $ctrl.order.companyName = val.companyName;
    $ctrl.order.retailerId = val.id;
    $ctrl.requirePO = val.poRequired;
    var shipOn = moment.utc(val.defaultShipOn);
    if (
      $ctrl.order.exported ||
      $ctrl.order.status == "Open" ||
      $ctrl.order.status == "Completed"
    ) {
      //do nothing since the ship date is set and we should just use what is there.
    } else {
      if (
        shipOn > moment() &&
        shipOn.year() !== 9998 &&
        shipOn < moment().add(5, "years") &&
        shipOn > $ctrl.order.shipOn
      ) {
        $ctrl.order.shipOn = shipOn;
        $ctrl.order.cancelOn = moment($ctrl.order.shipOn);
        $ctrl.order.cancelOn.add(1, "year");
      }
    }
    //console.info("ShippingNote: ", $ctrl.order.shippingNote);
    if (!$ctrl.order.id && val.shippingPayment)
      $ctrl.order.shippingNote = val.shippingPayment;

    if (retailerChanged || force) {
      if (!$ctrl.order.id && val.paymentTerms)
        $ctrl.order.paymentTermsId = val.paymentTerms;
      if (!$ctrl.order.id && val.shipMethod)
        $ctrl.order.shippingMethodId = val.shipMethod;
      if (!$ctrl.order.id && val.priceList)
        $ctrl.order.priceList = val.priceList;
      if (
        // !$ctrl.order.id &&   //commented this out because discount wouldn't get defaulted for orders that were copied
        val.discount &&
        $ctrl.orderConfig.defaultRetailerDiscount
      )
        $ctrl.order.discountPercentage = val.discount;
    }
    if (!$ctrl.emails || retailerChanged) {
      $ctrl.emails = [];
      $ctrl.emails = parseEmails(val.email);
      $ctrl.order.email = $ctrl.emails.join(",");
    }
    if((!$ctrl.emails || !$ctrl.emails.length) && $ctrl.order.createContactEmail) {
      $ctrl.emails = [];
      $ctrl.emails = parseEmails($ctrl.order.createContactEmail);
      $ctrl.order.email = $ctrl.emails.join(",");
    }
    if (!$ctrl.order.phone) {
      $ctrl.order.phone = val.phone;
    }
    if (val.isCreditHold && $ctrl.orderConfig.useCustomerCreditHoldOrderLogic) {
      $ctrl.order.status = "On Hold";
    }
    console.debug("Change Retailer", $ctrl.order.retailerId);
    $ctrl.locations.filter("RetailerId", $ctrl.order.retailerId);
    $ctrl.contacts.filter("RetailerId", $ctrl.order.retailerId);
    $ctrl.users.filter("RetailerId", $ctrl.order.retailerId);
    $ctrl.terms.filter("RetailerId", $ctrl.order.retailerId);
    $ctrl.shippingMethods.filter("shipViaId", val.shipMethod);
  }

  findVendors(val) {
    let $ctrl = this;
    let url = `QueryVendors.json?Active=1&Take=15&JsConfig=ExcludeDefaultValues&Search=${val}&OrderBy=Label`; //
    return $ctrl.bus
      .send(url, {
        op: "OrderHeaderFieldset",
        LimitVendorByRepGroup: $ctrl.orderConfig.limitVendorByRepGroup,
      })
      .then((res) => res.data.results);
  }

  findVendor(val) {
    let $ctrl = this;
    let url = `QueryVendors.json?Active=1&Take=15&JsConfig=ExcludeDefaultValues&id=${val}&OrderBy=Label`; //
    return $ctrl.bus
      .send(url, {
        op: "OrderHeaderFieldset",
      })
      .then((res) => res.data.results);
  }

  setVendor(vendor) {
    const $ctrl = this;
    //console.info("vendor", vendor);
    //console.info("$ctrl.order.vendor", $ctrl.order.vendor);
    //console.info("$ctrl.order.vendor.id", $ctrl.order.vendor.id);
    if (!vendor) vendor = {};
    $ctrl.order.vendor = vendor;
    $ctrl.order.vendorId = vendor.id;
    $ctrl.vendorSelected();
  }

  changeVendor() {
    const $ctrl = this;

    var vendor = $ctrl.vendors.results.filter(
      (v) => v.id === $ctrl.order.vendorId
    )[0];
    //console.info("vendor", vendor);
    if (!vendor) vendor = {};
    $ctrl.order.vendor = vendor;
    $ctrl.order.vendorId = vendor.id;
    $ctrl.vendorSelected();
  }

  changeBalance() {
    const $ctrl = this;
    $ctrl.order.balanceTotal = $ctrl.order.summaryTotal;
  }

  warehousesLoaded(args) {
    let $ctrl = this;
    //console.debug(
    //	"warehousesLoaded: ",
    //	args,
    //	$ctrl.order.warehouseId,
    //	$ctrl.order
    //);
    if (args.total === 1) {
      $ctrl.order.warehouseId = args.first.id;
    }
    $ctrl.changeWarehouse();
  }

  sourcesLoaded(args) {
    let $ctrl = this;
  }

  showcodesLoaded(args) {
    let $ctrl = this;
    console.info("$ctrl.order.showCodeId", $ctrl.order.showCodeId, $localStorage.showCodeId, args.total);
    console.info("$localStorage.showCodeId", $localStorage.showCodeId);
    if (
    	$ctrl.order.sourceId === $ctrl.$session.meta["DefaultOrderSourceShow"] &&
    	!$ctrl.order.showCodeId &&
    	$localStorage.showCodeId
    )
    	$ctrl.order.showCodeId = $localStorage.showCodeId;
    if (
    	$ctrl.order.sourceId === $ctrl.$session.meta["DefaultOrderSourceShow"] &&
    	!$ctrl.order.showCodeId &&
    	args.total >= 1
    )
    	$ctrl.order.showCodeId = args.results[0].id;
    console.info("$ctrl.order.showCodeId1", $ctrl.order.showCodeId);
  }

  showVendorLocationsLoaded(args) {
    let $ctrl = this;
    //console.info("$ctrl.order.showCodeId", $ctrl.order.showCodeId, $localStorage.showCodeId, args.total);
    //console.info("$localStorage.showCodeId", $localStorage.showCodeId);
    //if (
    //	$ctrl.order.sourceId === $ctrl.$session.meta["DefaultOrderSourceShow"] &&
    //	!$ctrl.order.showCodeId &&
    //	$localStorage.showCodeId
    //)
    //	$ctrl.order.showCodeId = $localStorage.showCodeId;
    //if (
    //	$ctrl.order.sourceId === $ctrl.$session.meta["DefaultOrderSourceShow"] &&
    //	!$ctrl.order.showCodeId &&
    //	args.total === 1
    //)
    //	$ctrl.order.showCodeId = args.results[0].id;
    //console.info("$ctrl.order.showCodeId1", $ctrl.order.showCodeId);
  }

  transactionTypesLoaded(args) {
    let $ctrl = this;
    if (!$ctrl.order.id) {
      args.results.forEach((type) => {
        if (type.isDefault) {
          $ctrl.order.type = type.id;
        }
      });
    }
    $ctrl.changeTransactionType();
  }

  termsLoaded(args) {
    let $ctrl = this;
    if (
      !$ctrl.order.id &&
      !$ctrl.order.paymentTermsId &&
      $ctrl.order.retailer.paymentTermsId
    ) {
      $ctrl.order.paymentTermsId = $ctrl.order.retailer.paymentTermsId;
      $ctrl.selectTerm();
    }
  }

  shippingMethodsLoaded(args) {
    let $ctrl = this;
    if (
      !$ctrl.order.id &&
      !$ctrl.order.shippingMethodId &&
      $ctrl.order.retailer.shipMethodId
    )
      $ctrl.order.shippingMethodId = $ctrl.order.retailer.shipMethodId;
  }

  locationsLoaded(args) {
    let $ctrl = this;
    //console.info("locationsLoaded", $ctrl.order, args);
    //console.info(
    //  "$ctrl.order.shippingLocationId",
    //  $ctrl.order.shippingLocationId
    //);
    const argsCount = args.results.length;
    if ($ctrl.order.retailerId && $ctrl.config.lblDropShip) {
      args.results.push({
        id: "DROPSHIP",
        name: $ctrl.config.lblDropShip,
      });
    }
    $ctrl.locations.stubs = args.results.map(
      ({
        id,
        name,
        companyName,
        address,
        address2,
        city,
        state,
        zip,
        country
      }) => ({
        id,
        name,
        companyName,
        address,
        address2,
        city,
        state,
        zip,
        country
      })
    );
    const matches = args.results.filter(
      (sl) => sl.id === $ctrl.order.shippingLocationId
    );
    //console.info("location loaded", matches);
    if (
      $ctrl.order.shippingLocationId === "DROPSHIP" ||
      $ctrl.order.shippingLocationId === "-1"
    ) {
      $ctrl.order.dropShip = true;
      return;
    }
    $ctrl.order.dropShip = false;
    if (matches.length > 0) {
      $ctrl.order.shippingLocation = matches[0];
    } else if (argsCount === 1) {
      $ctrl.order.shippingLocation = args.first;
      $ctrl.order.shippingLocationId = (args.first || {}).id;
      $ctrl.changeShippingLocation();
      //set ship via and terms from location if they have one
      // if (
      //   $ctrl.order.shippingLocation.shipMethod &&
      //   $ctrl.order.shippingLocation.shipMethod.id
      // ) {
      //   $ctrl.order.shippingMethodId =
      //     $ctrl.order.shippingLocation.shipMethod.id;
      //   $ctrl.shippingMethods.filter(
      //     "shipViaId",
      //     $ctrl.order.shippingLocation.shipMethod.id
      //   );
      // }
      // if (
      //   $ctrl.order.shippingLocation.paymentTerm &&
      //   $ctrl.order.shippingLocation.paymentTerm.id
      // ) {
      //   $ctrl.order.paymentTermsId =
      //     $ctrl.order.shippingLocation.paymentTerm.id;
      //   $ctrl.terms.filter("RetailerId", $ctrl.order.retailerId);
      // }
      // var shipOn = moment.utc($ctrl.order.shippingLocation.defaultShipOn);

      // if (
      //   $ctrl.order.exported ||
      //   $ctrl.order.status == "Open" ||
      //   $ctrl.order.status == "Completed"
      // ) {
      //   //do nothing since the ship date is set and we should just use what is there.
      // } else {
      //   if (
      //     shipOn > moment() &&
      //     shipOn.year() !== 9998 &&
      //     shipOn < moment().add(5, "years") &&
      //     shipOn > $ctrl.order.shipOn
      //   ) {
      //     $ctrl.order.shipOn = shipOn;
      //     $ctrl.order.cancelOn = moment($ctrl.order.shipOn);
      //     $ctrl.order.cancelOn.add(1, "year");
      //   }
      // }
    }
  }

  changeShippingLocation() {
    let $ctrl = this;
    //console.info("changeShippingLocation", $ctrl.order);
    if ($ctrl.order.shippingLocationId === "DROPSHIP") {
      $ctrl.order.dropShip = true;
      $ctrl.order.shippingLocation = {
        id: "DROPSHIP",
        dropShip: true,
        country: "US",
      };
    } else {
      const location = $ctrl.locations.results.filter(
        (r) => r.id === $ctrl.order.shippingLocationId
      )[0];
      //console.info("select location", location);
      $ctrl.order.shippingLocation = location;
      //set ship via from location if they have one
      if (
        location.shipMethod &&
        location.shipMethod.id &&
        $ctrl.shippingMethods
      ) {
        $ctrl.order.shippingMethodId = location.shipMethod.id;
        $ctrl.shippingMethods.filter("shipViaId", location.shipMethod.id);
      }
      if (location.paymentTerm && location.paymentTerm.id) {
        $ctrl.order.paymentTermsId = location.paymentTerm.id;
        $ctrl.terms.filter("RetailerId", $ctrl.order.retailerId);
        $ctrl.selectTerm();
      }
      if (
        // !$ctrl.order.id &&   //commented this out because discount wouldn't get defaulted for orders that were copied
        location.discount &&
        $ctrl.orderConfig.defaultRetailerDiscount
      )
        $ctrl.order.discountPercentage = location.discount > 0 ? location.discount : $ctrl.order.discountPercentage;

      if (location.email && location.email.indexOf("@") > 1 && $ctrl.orderConfig.useShippingLocationEmail) {
        $ctrl.order.email = location.email;
        $ctrl.emails = parseEmails(location.email);
        //add the email from order if it isn't a contact
        $ctrl.emails.forEach(function (email) {
          var orderEmail = $ctrl.contactsWithEmail.filter(function (obj) {
            return obj.email === email;
          });
          if (
            orderEmail === null ||
            (orderEmail.length === 0 && email && email !== "")
          ) {
            var contact = {
              name: "no name",
              email: email,
            };
            $ctrl.contactsWithEmail.push(contact);
          }
        });
      }
      $ctrl.order.dropShip = false;
      var shipOn = moment.utc(location.defaultShipOn);

      if (
        $ctrl.order.exported ||
        $ctrl.order.status == "Open" ||
        $ctrl.order.status == "Completed"
      ) {
        //do nothing since the ship date is set and we should just use what is there.
      } else {
        if (
          shipOn > moment() &&
          shipOn.year() !== 9998 &&
          shipOn < moment().add(5, "years") &&
          shipOn > $ctrl.order.shipOn
        ) {
          $ctrl.order.shipOn = shipOn;
          $ctrl.order.cancelOn = moment($ctrl.order.shipOn);
          $ctrl.order.cancelOn.add(1, "year");
        }
      }
      if ($ctrl.orderConfig.useShippingLocationContact) {
        $ctrl.order.buyer = location.contactName;
      }
    }
  }

  contactsLoaded(args) {
    let $ctrl = this;
    console.debug("BL*** contactsLoaded");
    const contact = args.results.filter((c) => c.isPrimary)[0];
    if (!$ctrl.order.id && !$ctrl.order.buyer && contact) {
      $ctrl.contact = contact;
      $ctrl.order.buyer = contact.name;
      if (contact.email && contact.email.indexOf("@") > 1) {
        $ctrl.order.email = contact.email;
        $ctrl.emails = parseEmails(contact.email);
      }
    }
  }

  changeShipDate() {
    let $ctrl = this;
    $ctrl.order.cancelOn = moment($ctrl.order.shipOn);
    if ($ctrl.orderConfig.cancelDateDays)
      $ctrl.order.cancelOn.add($ctrl.orderConfig.cancelDateDays, "day");
    else $ctrl.order.cancelOn.add(1, "year");
    if ($ctrl.config.maxCancelDaysAfterShip) {
      $ctrl.maxCancelDate = moment
      .utc($ctrl.order.shipOn)
      .add($ctrl.config.maxCancelDaysAfterShip, "days");
    }

  }

  changeTransactionType() {
    let $ctrl = this;
    $ctrl.containers.clear();
    $ctrl.warehouses.clear();
    $ctrl.warehouses.filter("TransactionTypeId", $ctrl.order.type);
    if (!$ctrl.isContainerOrder()) {
      $ctrl.order.warehouseId = null;
      $ctrl.order.containerId = null;
    } else {
      if ($ctrl.orderConfig.containerOrderPriceList) $ctrl.order.priceList = $ctrl.orderConfig.containerOrderPriceList;
    }
  }

  isContainerOrder() {
    let $ctrl = this;
    return (
      $ctrl.transactionTypes.results.filter(
        (r) => r.id === $ctrl.order.type && r.isContainer
      ).length > 0
    );
  }

  changeWarehouse() {
    let $ctrl = this;
    $ctrl.containers.clear();
    $ctrl.containers.filter("WarehouseId", $ctrl.order.warehouseId);
  }

  changeContainer() {
    let $ctrl = this;
  }

  createUser() {
    let $ctrl = this;
    if (!$ctrl.order.retailer.id) return;
    modals.prompt('Add User Email...')
    .result
    .then(email => {
      $ctrl.bus
      .send("RegisterUser.json", {
        autoLogin: false,
        role: "Retailer",
        retailerId: $ctrl.order.retailerId,
        password: "temporaryPassword",
        confirmPassword: "temporaryPassword",
        email: email,
        confirmEmail: email,
        permissions: "AllPermissions",
        forceResetPassword: true
      })
      .then(function () {
        $ctrl.users.push({
          fullName: email,
          email: email
        });
        $ctrl.shareWith = [];
        $ctrl.shareWith.push(email);
        if ($ctrl.shareWith.length) $ctrl.order.reviewedBy = $ctrl.shareWith.join(",");
      });
    });
  }


  priceListMapper(pl) {
    const $ctrl = this;
    pl.label = pl.priceListId;
    return pl;
  }

  priceListsLoaded(res) {
    const $ctrl = this;
    res.data.results.forEach((pl) => $ctrl.priceListMapper(pl));
    $ctrl.pricelists = res.data.results;
    $ctrl.filteredPricelists = [...$ctrl.pricelists];
    //need to get the customer default price list if exists
    if ($ctrl.order.retailerId) {
      $ctrl.bus
        .send(
          `QueryRetailerVendorPriceLists.json?GroupBy=PriceListId&RetailerId=${$ctrl.order.retailerId}&VendorId=${$ctrl.order.vendorId}`,
          {
            op: "OrderHeaderFieldset",
          }
        )
        .then(function (res) {
          //need to get the customer default price list if exists
          if (res.data.results.length > 0) {
            $ctrl.order.priceList = res.data.results[0].priceListId;
          }
        });
    }
  }
}
